import { Component } from '@angular/core';
import { TrashService } from 'src/app/shared/services/trash.service';

@Component({
  selector: 'app-machine-activity-trash',
  templateUrl: './machine-activity-trash.component.html',
  styleUrl: './machine-activity-trash.component.scss'
})
export class MachineActivityTrashComponent {
  constructor(
    private _tSvc: TrashService,
  ) { }

  public get TSvc(): TrashService {
    return this._tSvc;
  }
}
